import { makeRequest } from "./client";

export const termsApi = {
  /**
   * Accept terms and conditions
   */
  accept: async (
    orgId: string,
    token: string,
    data: {
      termsType: "shop" | "general";
      termsVersion: string;
      userName: string;
    }
  ): Promise<{
    message: string;
    acceptance: {
      termsType: string;
      termsVersion: string;
      userName: string;
      userId: string;
      orgId: string;
      acceptanceDate: string;
      acceptanceTimestamp: string;
    };
  }> => {
    return makeRequest(`/v1/org/${orgId}/terms`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(data),
    });
  },

  /**
   * Get terms acceptance status for the organization
   */
  getAll: async (
    orgId: string,
    token: string
  ): Promise<{
    acceptances: Array<{
      termsType: string;
      termsVersion: string;
      userName: string;
      userId: string;
      orgId: string;
      acceptanceDate: string;
      acceptanceTimestamp: string;
    }>;
  }> => {
    return makeRequest(`/v1/org/${orgId}/terms`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  /**
   * Get terms acceptance status for a specific type
   */
  getByType: async (
    orgId: string,
    token: string,
    termsType: "shop" | "general"
  ): Promise<{
    accepted: boolean;
    termsType: string;
    acceptance: {
      termsType: string;
      termsVersion: string;
      userName: string;
      userId: string;
      orgId: string;
      acceptanceDate: string;
      acceptanceTimestamp: string;
    } | null;
  }> => {
    return makeRequest(`/v1/org/${orgId}/terms?type=${termsType}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
